export class UpdateRemarksDto{
    assetServiceId:number;
    remarks?:string
}